import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressEcomBackInStockBackInStockSettingsServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'bo._base_domain_': [
      {
        srcPath: '/back-in-stock-service',
        destPath: '',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/back-in-stock-service',
        destPath: '',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/back-in-stock-service',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/back-in-stock-service',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/v1/back-in-stock-notification-requests',
        destPath: '/v1/back-in-stock-notification-requests',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/v1/back-in-stock-notification-requests',
        destPath: '/v1/back-in-stock-notification-requests',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_ecom_back-in-stock-settings';

/**
 * Sets `settings.collectionStates.collectingRequests` to `true` for given `appId`.
 *
 * When the collection state is set to `true`, collecting requests is enabled and customers may request
 * notifications for out of stock products. While collecting is enabled, customers see a "Notify When Available"
 * button on out-of-stock items. Customers can click the button to enter their email address, which creates the
 * notification request.
 */
export function startCollectingRequests(
  payload: object
): RequestOptionsFactory<any> {
  function __startCollectingRequests({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.ecom.v1.back_in_stock_settings',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.ecom.back.in.stock.BackInStockSettingsService.StartCollectingRequests',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressEcomBackInStockBackInStockSettingsServiceUrl({
        protoPath:
          '/v1/back-in-stock-notification-requests/settings/start-collecting',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __startCollectingRequests;
}

/**
 * Sets `settings.collectionStates.collectingRequests` to `false` for given `appId`.
 *
 * When the collection state is set to `false`, collecting notification requests is disabled.
 */
export function stopCollectingRequests(
  payload: object
): RequestOptionsFactory<any> {
  function __stopCollectingRequests({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.ecom.v1.back_in_stock_settings',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.ecom.back.in.stock.BackInStockSettingsService.StopCollectingRequests',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressEcomBackInStockBackInStockSettingsServiceUrl({
        protoPath:
          '/v1/back-in-stock-notification-requests/settings/stop-collecting',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __stopCollectingRequests;
}

/** Retrieves back in stock notification request settings. */
export function getSettings(payload: object): RequestOptionsFactory<any> {
  function __getSettings({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.ecom.v1.back_in_stock_settings',
      method: 'PUT' as any,
      methodFqn:
        'com.wixpress.ecom.back.in.stock.BackInStockSettingsService.GetSettings',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressEcomBackInStockBackInStockSettingsServiceUrl({
        protoPath: '/v1/back-in-stock-notification-requests/settings',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __getSettings;
}
